<template>
	<Survey
		:surveyId="surveyId"
		@getEventSurvey="updatePage"
		:surveyQuestions="surveyQuestions"
		:surveyTypeQuiz="surveyTypeQuiz"
		:totalSteps="totalSteps"
		:currentStep="currentStep"
	/>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Survey from '@/components/Event/Survey.vue'

export default {
	data() {
		return {
			type: '',
			surveyName: '',
		}
	},
	components: {
		Survey,
	},
	computed: {
		...mapGetters('event', ['survey', 'isLoadingSurvey', 'surveyError', 'surveyPostError']),
		surveyId() {
			return this.survey.survey_id || 0
		},
		surveyQuestions() {
			if (this.survey?.step_question) return [this.survey.step_question]
			return this.survey?.survey_questions || []
		},
		totalSteps() {
			return this.survey?.total_steps || 1
		},
		currentStep() {
			return this.survey?.current_step || 1
		},
		surveyTypeQuiz() {
			return this.survey.survey_type === 'classic'
		},
		questionCounter() {
			if (this.surveyTypeQuiz) {
				return this.survey.survey_name
			} else {
				return `Question ${this.currentStep} of ${this.totalSteps}`
			}
		},
	},
	watch: {
		survey: {
			immediate: true,
			handler(val) {
				if (val) this.setPageTitle(this.questionCounter)
			},
		},
	},
	methods: {
		...mapActions('event', ['getEventSurvey']),
		...mapActions('app', ['setPageTitle']),
		async updatePage() {
			await this.getEventSurvey({
				id: this.$route.params.id,
				type: this.$route.query.type,
			})
		},
	},
	created() {
		this.getEventSurvey({
			id: this.$route.params.id,
			type: this.$route.query.type,
		})
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
}
</script>

<style lang="scss">
.survey-form {
	max-width: 555px;
	font-family: 'Inter', sans-serif;
	display: flex;
	gap: 12px;
	height: 100%;
	padding-bottom: 20px;

	flex-direction: column;
	justify-content: space-between;
	&__form {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: center;
	}
	&__grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		grid-column-gap: 8px;
		grid-row-gap: 8px;
	}
	&__grid-item {
		display: flex;
		align-items: center;
		padding: 12px 12px 13px 12px;
		background: #ffffff;
		border-radius: 10px;

		&.survey-form__checkbox__selected {
			border: 1px solid #e2e2e2;
		}
		&.full-span {
			grid-column: 1 / -1;
		}
	}

	&__title {
		font-weight: 700;
		font-size: 20px;
		line-height: 22px;
		letter-spacing: 0;
		text-align: center;
		color: #002855;
		margin-bottom: 12px;
	}

	&__label {
		font-weight: 500;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		color: #002855;
	}
	&__radio {
		display: flex;
		align-items: baseline;
		padding: 12px 12px 13px 12px;
		background: #ffffff;
		gap: 8px;
		border-radius: 10px;
		margin-top: 8px;
	}
	&__radio__custom {
		display: flex;
		flex-direction: column;
		background: #ffffff;
		border-radius: 10px;
		padding: 12px 12px 13px 12px;
		align-items: baseline;
		gap: 8px;
	}
	&__radio__selected {
		border: 1px solid #e2e2e2;
	}

	&__checkbox {
		display: flex;
		align-items: baseline;
		padding: 12px 12px 13px 12px;
		background: #ffffff;
		gap: 8px;
		border-radius: 10px;
		margin-bottom: 8px;
	}
	&__checkbox__selected {
		border: 1px solid #e2e2e2;
	}

	&__custom-answer {
		display: flex;
		flex-direction: column;
		background: #ffffff;
		border-radius: 10px;
		padding: 12px 12px 13px 12px;
		align-items: baseline;
		gap: 8px;

		&__input {
			width: 100%;
			min-height: 24px;
			font-weight: 400;
			font-size: 16px;
			line-height: 140%;
			letter-spacing: 0;
			padding: 0;
			height: auto;
			border: none;
			outline: none;
			background-color: #ffffff;
			resize: none;
			overflow-wrap: break-word;
			white-space: pre-wrap;
			font-family: inherit;

			&::placeholder {
				font-weight: 400;
				font-size: 18px;
				line-height: 140%;
				letter-spacing: 0;
				color: #9b9b9b;
			}
		}
	}
	@media (max-width: 480px) {
		&__grid {
			grid-template-columns: 1fr;
		}
	}
}
</style>
